import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { departmanDagilim } from '../lib/listStats'
import type { Personel } from '../types'
import { SectionCard } from './SectionCard'

export function PersonelSideWidgets({ list }: { list: Personel[] }) {
  const { t } = useTranslation()
  const dagilim = useMemo(() => departmanDagilim(list), [list])

  return (
    <div className="space-y-4">
      <SectionCard title={t('hr.personel.widgets.departman')}>
        <div className="space-y-4">
          {dagilim.map((d) => (
            <div key={d.name} className="space-y-2">
              <div className="flex items-center justify-between gap-2 text-sm">
                <span className="truncate font-medium">{d.name}</span>
                <span className="shrink-0 tabular-nums text-muted-foreground">
                  {d.count}
                  <span className="ml-1.5 text-xs">%{d.pct}</span>
                </span>
              </div>
              <div className="h-2.5 overflow-hidden rounded-full bg-muted">
                <div className="h-full rounded-full bg-primary transition-all" style={{ width: `${d.pct}%` }} />
              </div>
            </div>
          ))}
        </div>
      </SectionCard>

      <SectionCard title={t('hr.personel.widgets.yaklasan')}>
        <div className="space-y-3">
          <p className="text-sm text-muted-foreground">{t('hr.personel.widgets.bos')}</p>
        </div>
      </SectionCard>
    </div>
  )
}
